import { getEnv } from './envConfig'
let env = getEnv()

export const ENDPOINT = env.ENDPOINT
export const KEYCLOAK_URL = env.KEYCLOAK_URL
export const ROLES = '/api/roles';
export const JOURNALISTS = '/api/employees';
export const ADMIN_ACCOUNTS = '/api/employees';
export const CATEGORY = '/api/categories';
export const TOPIC = '/api/topics';
export const USERS = '/api/employees';
export const CONTRIBUTIONS = '/api/contributions';
export const DASHBOARD = '/api/dashboard';
export const PASSWORD_RESET = '/api/employee/password_reset';
export const ANONYMOUS_LOGIN = '/api/employees/anonymous-login';

